//This should map the CurrentPageProgress enum in GeneralHelpers
export enum PageType {
    Unknown = 0,
    Personal = 1,
    Contact = 2,
    Screening = 3,
    AppForm = 4,
    Declarations = 5,
    PolicyOwnership = 6,
    Payment = 7,
    Address = 8,
    Consent = 9,
    Signature = 10,
    Submit = 11,
    Done = 12
};

export const PageList: PageType[] = [
    PageType.Personal,
    PageType.Contact,
    PageType.Screening,
    PageType.AppForm,
    PageType.Declarations,
    PageType.PolicyOwnership,
    PageType.Payment,
    PageType.Address,
    PageType.Consent,
    PageType.Signature,
    PageType.Submit
];

//export const PageTypeDescription : Map<PageType, string> = [
//    [PageType.Personal, "Personal Details"],
//    [PageType.Contact, "Contact Details"],
//    [PageType.Screening, "Initial Requirements"],
//    [PageType.AppForm, "Underwriting"],
//    [PageType.Declarations, "Declarations"],
//    [PageType.PolicyOwnership, "Policy Ownership"],
//    [PageType.Payment, "Payment"],
//    [PageType.Address, "Address"],
//    [PageType.Consent, "Consent"],
//    [PageType.Signature, "Signature"],
//    [PageType.Payment, "Submit"],
//];
